import React, { Component, useState } from "react";
import PopupWindow from "./PopupWindow";
import LoginButton from "./LoginButton";
import { authAPI } from "../api/api";
import { localStorageService } from "../utils/localStorageService";

import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
  Tooltip
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";


const tokenBoxStyles = {
  flex: 1,
  fontFamily: "monospace",
  fontSize: "0.85rem",
  backgroundColor: "#f5f5f5",
  padding: "6px 12px",
  borderRadius: "4px",
  width: "300px",
  height: "32px",
  boxSizing: "border-box",
  overflowX: "scroll",
  overflowY: "hidden",
  whiteSpace: "nowrap",
  lineHeight: "16px",
  display: "flex",
  alignItems: "center",
  "&::-webkit-scrollbar": {
    height: "4px"
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "transparent"
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#999",
    borderRadius: "2px",
    "&:hover": {
      backgroundColor: "#666"
    }
  }
};


const ToastDialog = ({ open, onClose, message, accessToken }) => {
  // const accessToken = "asdfasdfasdf-asdfvcas-afsdfasd-asdfasd"
  const [showToken, setShowToken] = useState(false);
  const [copied, setCopied] = useState(false);

  const maskToken = (token) => {
    if (!token) return "";
    const tokenStr = typeof token === "object" ? token.accessToken : token;
    if (!tokenStr) return "";
    return "•".repeat(Math.min(tokenStr.length, 40));
  };

  const getDisplayToken = () => {
    if (!accessToken) return "";
    return typeof accessToken === "object" ? accessToken.accessToken : accessToken;
  };

  const handleCopy = async () => {
    const tokenToCopy = getDisplayToken();
    if (tokenToCopy) {
      await navigator.clipboard.writeText(tokenToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };


  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle
        style={{ display: "flex", alignItems: "center", gap: "8px" }}
      >
        <CheckCircleIcon color="success" />
        Successful
      </DialogTitle>
      <DialogContent dividers>{message}
        <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Access Token:
          </Typography>
          <Box sx={tokenBoxStyles}>
            {showToken ? getDisplayToken() : maskToken(accessToken)}
          </Box>
          <Tooltip title={showToken ? "Hide token" : "Show token"}>
            <IconButton
              size="small"
              onClick={() => setShowToken(!showToken)}
              sx={{ color: "#666" }}
            >
              {showToken ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </IconButton>
          </Tooltip>
          <Tooltip title={copied ? "Copied!" : "Copy token"}>
            <IconButton
              size="small"
              onClick={handleCopy}
              sx={{ color: copied ? "#4caf50" : "#666" }}
            >
              <ContentCopyIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={onClose}
          variant="contained"
          // color="success"
          size="small"
          style={{ background: "#DF9307" }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

class PNZLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toast: false,
      accessToken: null,
    };
  }

  onBtnClick = async () => {
    try {
      const accountconsent = await authAPI.accountconsent();
      const initiatecodegrant = await authAPI.initiatecodegrant(
        accountconsent.data.consentId
      );
      const redirectUri = initiatecodegrant.data.redirect;
      const left = window.screen.width / 2 - 300;
      const top = window.screen.height / 2 - 500;
      const popup = (this.popup = PopupWindow.open(
        "pnz-oauth-authorize",
        `${redirectUri}`,
        { height: 1000, width: 600, left, top }
      ));

      popup.then(
        (data) => this.onSuccess(data),
        (error) => this.onFailure(error)
      );
    } catch (error) {
      this.onFailure();
    }
  };

  onSuccess = async (data) => {
    if (!data.code) {
      return this.onFailure(new Error("'code' not found"));
    }
    try {
      const accessToken = await authAPI.accesstoken(data.code);

      this.props?.setAccessToken(accessToken.data.accessTokenObject);
      localStorageService.setAccessToken(accessToken.data.accessTokenObject);

      this.setState({ toast: true, accessToken: accessToken.data.accessTokenObject });
    } catch (error) {
      this.onFailure(error);
    }
  };

  onToastClose = () => {
    this.setState({ toast: false });
  };

  onFailure = (error) => {
    console.log(error);
  };
  render() {
    const attrs = { onClick: this.onBtnClick };
    return (
      <>
        <LoginButton at={attrs} />
        <ToastDialog
          open={this.state.toast}
          onClose={this.onToastClose}
          message="Authentication successful! Your API token is now active and will be automatically included in all your API requests."
          accessToken={this.state.accessToken}
        />
      </>
    );
  }
}

export default PNZLogin;
